var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsTranslated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 90,
    viewBox: "0 0 53 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    x: 22,
    y: 42,
    width: 31,
    height: 6,
    rx: 1,
    fill: "#00071A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    x: 4,
    width: 49,
    height: 6,
    rx: 1,
    fill: "#00071A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    x: 3,
    y: 14,
    width: 50,
    height: 6,
    rx: 1,
    fill: "#00071A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    y: 28,
    width: 53,
    height: 6,
    rx: 1,
    fill: "#00071A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    x: 22,
    y: 84,
    width: 31,
    height: 6,
    rx: 1,
    fill: "#00071A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    x: 3,
    y: 56,
    width: 50,
    height: 6,
    rx: 1,
    fill: "#00071A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    y: 70,
    width: 53,
    height: 6,
    rx: 1,
    fill: "#00071A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsTranslated);
export default __webpack_public_path__ + "static/media/detailsTranslated.b29f64e3b65fee73b0ba9982bbb30d8c.svg";
export { ForwardRef as ReactComponent };